import styled from '@emotion/styled';
import { Button } from '@lightspeed/flame/Button';
import { Flex } from '@lightspeed/flame/Core';
import { Switch } from '@lightspeed/flame/Switch';
import { Text } from '@lightspeed/flame/Text';

export const StyledFlex = styled(Flex)`
  border-left: 1px solid #ddd;
  background-color: #ffffff;
  padding: 6px;
`;

export const StyledButton = styled(Button)`
  height: 30px;
  width: 102px;
  padding-right: 10px;
  padding-left: 10px;
  text-align: left;
  span > span {
    padding: 6px 2px !important;
  }
`;

export const StyledText = styled(Text)`
  line-height: 18px;
`;

export const StyledInputContainer = styled.div`
  position: relative;
  min-width: 112px;
  width: 20%;
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
`;

export const StyledInput = styled.input`
  text-align: center;
`;

export const StyledSelectContainer = styled.div`
  padding-left: 6px;
  padding-right: 6px;
  width: 100%;
  border-bottom: 1px solid #ddd;
  margin-top: 5px;
`;

export const StyledSelect = styled.select`
  width: 100%;
`;

export const StyledInputIcon = styled.span`
  position: absolute;
  left: 4px;
  top: 50%;
  transform: translateY(-50%);
  color: #8b939b;
`;

export const StyledInputRow = styled(Flex)`
  flex-direction: row;
  min-width: 463px;
`;

export const StyledLabelContainer = styled.div`
  text-align: left;
  padding-top: 6px !important;
  min-width: 50%;
`;

export const StyledIframe = styled('iframe')`
  width: 100%;
  height: 100%;
  border: none;
`;

export const StyledBalanceOwedValue = styled.div`
  text-align: center;
  padding-left: 6px;
  padding-right: 6px;
  width: 100%;
  border-bottom: 1px solid #ddd;
  margin-top: 5px;
`;

export const StyledSwitch = styled(Switch)`
  span {
    padding: 0 !important;
  }
`;
